import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { TiposTablaPersonalizadaConstant, CodigosTransaccionesConstant } from 'constants/index'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'

const UnicoLista = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarEditarModal, setMostrarEditarModal] = React.useState(false)

  const tablaRef = React.useRef(null)
  const editarData = React.useRef({})

  const nombreTabla = React.useMemo(() => {
    return TiposTablaPersonalizadaConstant.__dictionary[match.params.tipoTabla].nombre
  }, [match.params.tipoTabla])

  const portletBreadcrumbs = React.useMemo(() => {
    return [
      { name: 'Tablas Personalizadas', path: `/${CodigosTransaccionesConstant.TABLASPERSONALIZADAS_MAIN}` },
      { name: nombreTabla }
    ]
  }, [nombreTabla])

  const headColumns = React.useMemo(() => {
    switch (match.params.tipoTabla) {
      case TiposTablaPersonalizadaConstant.PLANTILLACOMENTARIOVENTA:
      case TiposTablaPersonalizadaConstant.ISLAGRIFO:
      case TiposTablaPersonalizadaConstant.LISTAPRECIO:
        return [{ label: 'NOMBRE' }]
      case TiposTablaPersonalizadaConstant.PRECIOXLISTA:
        return [{ label: 'LISTA' }, { label: 'NOMBRE' }]
      case TiposTablaPersonalizadaConstant.AREASINTERNAS:
        return [{ label: 'CODIGO' }, { label: 'NOMBRE' }]
      case TiposTablaPersonalizadaConstant.MONEDA:
        return [{ label: 'CODIGO' }, { label: 'NOMBRE' }, { label: 'VALOR SUNAT' }]
      case TiposTablaPersonalizadaConstant.GRUPOCONTABLECOMPRA:
      case TiposTablaPersonalizadaConstant.GRUPOCONTABLEVENTA:
      case TiposTablaPersonalizadaConstant.GRUPOCONTABLEEXISTENCIA:
      case TiposTablaPersonalizadaConstant.GRUPOCONTABLEINVENTARIO:
        return [{ label: 'NOMBRE' }, { label: 'CUENTA CONTABLE' }]
      case TiposTablaPersonalizadaConstant.CONDUCTOR:
        return [{ label: 'BREVETE' }, { label: 'TIPO DOC' }, { label: 'NUMERO DOC' }]
      case TiposTablaPersonalizadaConstant.PLACA:
        return [{ label: 'MARCA' }, { label: 'PLACA' }]
      case TiposTablaPersonalizadaConstant.SUSTRACCIONVENTAS:
        return [{ label: 'NOMBRE' }, { label: 'PORCENTAJE' }]
      case TiposTablaPersonalizadaConstant.TRANSPORTISTA:
        return [{ label: 'TIPO DOC' }, { label: 'NUMERO DOC' }, { label: 'RAZON SOCIAL' }]
      case TiposTablaPersonalizadaConstant.OFICINA:
        return [{ label: 'NOMBRE' }]
      default:
        return [{ label: 'CODIGO' }, { label: 'NOMBRE' }]
    }
  }, [match.params.tipoTabla])

  const rowBaseTemplate = React.useCallback(
    row => {
      switch (match.params.tipoTabla) {
        case TiposTablaPersonalizadaConstant.PLANTILLACOMENTARIOVENTA:
        case TiposTablaPersonalizadaConstant.ISLAGRIFO:
        case TiposTablaPersonalizadaConstant.LISTAPRECIO:
          return (
            <>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
            </>
          )
        case TiposTablaPersonalizadaConstant.PRECIOXLISTA:
          return (
            <>
              <Table.Cell>{row.listaPrecio || '--'}</Table.Cell>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
            </>
          )
        case TiposTablaPersonalizadaConstant.AREASINTERNAS:
          return (
            <>
              <Table.Cell>{row.codigo || '--'}</Table.Cell>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
            </>
          )
        case TiposTablaPersonalizadaConstant.MONEDA:
          return (
            <>
              <Table.Cell>{row.codigo || '--'}</Table.Cell>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
              <Table.Cell>{row.valorSunat || '--'}</Table.Cell>
            </>
          )
        case TiposTablaPersonalizadaConstant.GRUPOCONTABLECOMPRA:
        case TiposTablaPersonalizadaConstant.GRUPOCONTABLEVENTA:
        case TiposTablaPersonalizadaConstant.GRUPOCONTABLEEXISTENCIA:
        case TiposTablaPersonalizadaConstant.GRUPOCONTABLEINVENTARIO:
          return (
            <>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
              <Table.Cell>{row.cuentaContable || '--'}</Table.Cell>
            </>
          )
        case TiposTablaPersonalizadaConstant.CONDUCTOR:
          return (
            <>
              <Table.Cell>{row.brevete || '--'}</Table.Cell>
              <Table.Cell>{row.tipoDocumentoIdentificacion || '--'}</Table.Cell>
              <Table.Cell>{row.numeroDocumentoIdentificacion || '--'}</Table.Cell>
            </>
          )
        case TiposTablaPersonalizadaConstant.PLACA:
          return (
            <>
              <Table.Cell>{row.marca || '--'}</Table.Cell>
              <Table.Cell>{row.placa || '--'}</Table.Cell>
            </>
          )
        case TiposTablaPersonalizadaConstant.SUSTRACCIONVENTAS:
          return (
            <>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
              <Table.Cell>{row.porcentaje || '--'}</Table.Cell>
            </>
          )
        case TiposTablaPersonalizadaConstant.TRANSPORTISTA:
          return (
            <>
              <Table.Cell>{row.tipoDocumentoIdentificacion || '--'}</Table.Cell>
              <Table.Cell>{row.numeroDocumentoIdentificacion || '--'}</Table.Cell>
              <Table.Cell>{row.razonSocial || '--'}</Table.Cell>
            </>
          )
        case TiposTablaPersonalizadaConstant.OFICINA:
          return (
            <>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
            </>
          )
        default:
          return (
            <>
              <Table.Cell>{row.codigo || '--'}</Table.Cell>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
            </>
          )
      }
    },
    [match.params.tipoTabla]
  )

  const clickNuevo = React.useCallback(() => {
    editarData.current = {}
    setMostrarEditarModal(true)
  }, [])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      TablasPersonalizadasService.getAsEdicion(_id)
        .then(({ data }) => {
          editarData.current = {
            ...data,
            _id: _id
          }
          setMostrarEditarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      TablasPersonalizadasService.eliminarxId(_id)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha eliminado.')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const onModalSuccess = React.useCallback(() => {
    tablaRef.current.reload()
    setMostrarEditarModal(false)
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Tablas Personalizadas'
          buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
          breadcrumbs={portletBreadcrumbs}
        />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            useNest={true}
            url='/tablas-personalizadas'
            baseParams={{
              tipo: match.params.tipoTabla,
              nivelConsulta: match.params.tipoTabla === TiposTablaPersonalizadaConstant.ISLAGRIFO ? 'sede' : ''
            }}
            headRows={[...headColumns, { label: '' }]}
            rowTemplate={row => (
              <Table.Row key={row._id}>
                {rowBaseTemplate(row)}
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='editar'
                        handleClose={handleClose}
                        onClick={e => clickEditar({ _id: row._id })}
                      >
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='eliminar'
                        handleClose={handleClose}
                        onClick={e => clickEliminar({ _id: row._id })}
                      >
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarEditarModal && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={() => setMostrarEditarModal(false)}
          show={mostrarEditarModal}
          modalData={editarData.current}
          tipoTabla={match.params.tipoTabla}
          onSuccess={onModalSuccess}
        />
      )}
    </>
  )
}

export default React.memo(UnicoLista)
